export const menuItems = [
    'Factsheet',
    'Description',
    'History',
    'Projects',
    'Videos',
    'Images',
    'Logo & Icon',
    'Awards & Recognition',
    'Selected Articles',
    'Team',
    'Contact',
];
